import type { BimActKc2OtherItemData } from 'gql/graphql';
import type { IUseAccess } from 'hooks/useAccess';
import { useAccess } from 'hooks/useAccess';
import { ActKc2Title } from 'pages/Project/Common/ActKc2Title/ActKc2Title';
import { Button, ContextMenu, IconKebab } from 'uikit';
import type { ContextMenuItemDefault } from 'uikit';

import type { IHeaderParams } from 'ag-grid-community';
import type React from 'react';
import { useCallback, useRef, useState } from 'react';

interface IActHeaderComponents extends IHeaderParams {
    actKc2Other: BimActKc2OtherItemData;
    menuItemsGetter: (
        actKc2Other: BimActKc2OtherItemData,
        aktKC2BimOtherRules: IUseAccess['aktKC2BimOther'],
    ) => ContextMenuItemDefault[];
}

const containerStyle = { display: 'flex', alignItems: 'center', width: '100%' };

export const ActHeaderComponent: React.FC<IActHeaderComponents> = (props) => {
    const { actKc2Other, menuItemsGetter } = props;
    const [isContextOpen, setIsContextOpen] = useState<boolean>(false);
    const { aktKC2BimOther: aktKC2BimOtherRules } = useAccess({ statusKC2: actKc2Other.status });

    const ref = useRef(null);

    const onContextMenuButtonClick = useCallback(() => {
        setIsContextOpen((prevState) => !prevState);
    }, []);

    return (
        <div style={containerStyle}>
            <ActKc2Title act={actKc2Other} size="s" includeTitle />
            <Button
                onlyIcon
                iconLeft={IconKebab}
                size="xs"
                iconSize="s"
                view="clear"
                style={{ marginLeft: 'auto' }}
                onClick={onContextMenuButtonClick}
                ref={ref}
            />
            <ContextMenu
                anchorRef={ref}
                isOpen={isContextOpen}
                onClickOutside={onContextMenuButtonClick}
                items={menuItemsGetter(actKc2Other, aktKC2BimOtherRules)}
                direction="downStartLeft"
                size="s"
            />
        </div>
    );
};

ActHeaderComponent.displayName = 'ActHeaderComponents';
